import { API_LASTBRAND_CUSTOMER_ENDPOINT, API_QUINCE_CUSTOMER_ENDPOINT } from '@src/config/env'

import { FEATURES, MODULES } from '../../constants/template-info'
import QuinceApiError from '../../domains/quince-api-error'
import { captureException } from '../../utils/sentryUtil'

export interface CheckOldUserResponse {
  response: string | null
  error: string | null
}

class CustomerService {
  async isOldUser(email: string): Promise<CheckOldUserResponse> {
    const options = {
      // @i18n-ignore
      method: 'POST',
      body: JSON.stringify({ email: email }),
      headers: {
        // @i18n-ignore
        'Content-Type': 'application/json',
      },
    }
    try {
      const response = await fetch(`${API_LASTBRAND_CUSTOMER_ENDPOINT}isOldUser/v2`, options)
      return { response: await response.text(), error: null }
    } catch (error) {
      const quinceApiError = new QuinceApiError({
        apiName: 'IS_OLD_USER',
        message: `Error in Fetching customer state: ${email}`,
        error: error as Error,
        data: {
          email,
        },
      })
      captureException(quinceApiError, {
        module: MODULES.CUSTOMER,
        feature: FEATURES.IS_OLD_USER,
      })

      return { response: null, error: String(error) }
    }
  }
  public async getUUID(email: string): Promise<string> {
    const options = {
      // @i18n-ignore
      method: 'GET',
      headers: {
        // @i18n-ignore
        'Content-Type': 'text/plain',
      },
    }
    // @i18n-ignore
    const urlParams = `uuid?email=${email}`
    try {
      const response = await fetch(API_QUINCE_CUSTOMER_ENDPOINT + urlParams, options)
      if (response.ok) {
        return await response.text()
      } else {
        const quinceApiError = new QuinceApiError({
          apiName: 'GET_UUID',
          message: `Error in Fetching customer uuid: ${email}`,
          error: new Error(`Error in Fetching customer uuid: ${email}, failed with status code ${response.status}`),
          data: {
            email,
          },
        })
        captureException(quinceApiError, {
          module: MODULES.CUSTOMER,
          feature: FEATURES.GET_UUID,
        })

        return null
      }
    } catch (e) {
      const quinceApiError = new QuinceApiError({
        apiName: 'GET_UUID',
        message: `Error in Fetching customer uuid: ${email}`,
        error: e as Error,
        data: {
          email,
        },
      })
      captureException(quinceApiError, {
        module: MODULES.CUSTOMER,
        feature: FEATURES.GET_UUID,
      })
      return String(e)
    }
  }
}

const customerService = new CustomerService()

export default customerService
